export enum DataExchangeDeadlineOutcomeDto {
  None = 0,
  InTime = 1,
  Late = 2
}
